var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
    ? _c("div", { staticClass: "collection-grid-header" }, [
        _c(
          "div",
          {
            staticClass: "collection-grid-header__sort-pagination-total-wrapper"
          },
          [
            _c("collection-total-results"),
            _vm.$mq === "tablet" || !_vm.filtersDisabled
              ? _c("collection-sorting", {
                  staticClass: "sorting",
                  attrs: {
                    "default-sort": _vm.defaultSort,
                    value: _vm.currentSort
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _c("div", { ref: "filterAndSortButtons" }, [
        _c(
          "div",
          {
            staticClass: "collection-grid-header__mobile",
            class: {
              "collection-grid-header__mobile--fixed": _vm.fixedMobileHeader,
              zindex30:
                _vm.mobileFiltersMenuActive || _vm.mobileSortingMenuActive
            }
          },
          [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c(
                  "div",
                  { staticClass: "collection-grid-header__mobile-menu" },
                  [
                    !_vm.filtersDisabled &&
                    _vm.filters &&
                    _vm.filters.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "collection-grid-header__mobile-menu-button button--primary",
                            on: { click: _vm.toggleMobileFiltersMenu }
                          },
                          [
                            _vm.currentFilters.length > 0
                              ? _c("div", { staticClass: "h6" }, [
                                  _vm._v(
                                    "FILTERS\n (" +
                                      _vm._s(_vm.currentFilters.length) +
                                      ")"
                                  )
                                ])
                              : _c("div", { staticClass: "h6" }, [
                                  _vm._v("FILTERS")
                                ])
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "collection-grid-header__mobile-menu-button button--secondary",
                        style:
                          _vm.filters && _vm.filters.length > 0
                            ? ""
                            : "width: 100%",
                        on: { click: _vm.toggleMobileSortingMenu }
                      },
                      [_c("div", { staticClass: "h6" }, [_vm._v("SORT")])]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "collection-grid-header__mobile-menu-results-wrapper"
                  },
                  [_c("collection-total-results")],
                  1
                ),
                _c(
                  "collection-mobile-menu",
                  {
                    attrs: {
                      "menu-active": _vm.mobileFiltersMenuActive,
                      "close-binding": _vm.toggleMobileFiltersMenu,
                      "enable-apply-button": true,
                      "enable-clear-all": true,
                      "menu-title": "Filters",
                      "hero-settings": _vm.heroSettings
                    }
                  },
                  [
                    _c("collection-filters", {
                      staticClass: "collection-grid__filters",
                      attrs: {
                        tags: _vm.tags,
                        filters: _vm.filters,
                        "hero-settings": _vm.heroSettings
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "collection-mobile-menu",
                  {
                    attrs: {
                      "menu-active": _vm.mobileSortingMenuActive,
                      "close-binding": _vm.toggleMobileSortingMenu,
                      "menu-title": "Sort By"
                    }
                  },
                  [
                    _c("collection-sorting", {
                      attrs: {
                        "default-sort": _vm.defaultSort,
                        "mobile-click-binding": _vm.toggleMobileSortingMenu,
                        value: _vm.currentSort
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }